import React from 'react';
import ReactApexChart from 'react-apexcharts';

const TotalUserChart = (props) => {
  const state = {
    series: [
      {
        name: 'Contact',
        type: 'bar',
        data: props?.data?.week_wise_counts,
      },
    ],

    options: {
      chart: {
        height: 160,
        type: 'bar',
        toolbar: {
          show: false,
          autoSelected: false,
          tools: {
            download: false,
          },
        },
      },

      plotOptions: {
        bar: {
          borderRadius: 0,
          borderRadiusApplication: 5,
          borderRadiusWhenStacked: 0,
          dataLabels: {
            position: 'center',
          },
          strokeWidth: 3,
          columnWidth: '40%',
        },
      },
      fill: {
        type: 'gradient',
        gradient: {
          type: 'vertical',
          colorStops: [
            {
              offset: 0,
              color: '#b94feb',
            },
            {
              offset: 100,
              color: '#f4543a',
            },
          ],
        },
      },
      dataLabels: {
        enabled: false,
        formatter: function (val) {
          return val;
        },
        offsetY: 0,
        style: {
          fontSize: '20px',
          colors: ['#666666'],
        },
      },

      grid: {
        show: true,
        borderColor: '#F2ECEC',
        strokeDashArray: 10,
        xaxis: {
          lines: {
            show: false,
          },
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
        row: {
          colors: undefined,
          opacity: 0.5,
        },
        column: {
          colors: undefined,
          opacity: 0.5,
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
      },
      xaxis: {
        categories: props?.data?.day || ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        position: 'bottom',
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          style: {
            colors: '#666666',
            fontSize: '14px',
          },
        },
        tooltip: {
          enabled: true,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          formatter: function (val) {
            return val;
          },
        },
      },
    },
  };

  return (
    <div className='react-chart'>
      <ReactApexChart options={state.options} series={state.series} type='bar' height={160} />
    </div>
  );
};

export default TotalUserChart;
